import { Alert, Button, Card, LoadingState } from '@orbind/ui'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { api, webTokenStorage } from '../lib/api.ts'
import { OrbindLogo } from '../shell/OrbindLogo.tsx'
import './login.css'

/**
 * Destino do link do e-mail de confirmacao (SPEC-20260814-1922): troca o token
 * por uma sessao e entra direto no workspace criado no cadastro.
 */
export function ConfirmEmailPage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [estado, setEstado] = useState<'confirmando' | 'erro'>('confirmando')
  const disparado = useRef(false)

  useEffect(() => {
    if (disparado.current) return
    disparado.current = true
    if (token === '') {
      setEstado('erro')
      return
    }
    void (async () => {
      try {
        const resposta = await api.onboarding['confirm-email'].$post({ json: { token } })
        const dados = await resposta.json()
        webTokenStorage.set(dados.token)
        navigate('/home', { replace: true })
      } catch {
        setEstado('erro')
      }
    })()
  }, [token, navigate])

  return (
    <div className="ob-root login">
      <section className="login__brand" aria-hidden>
        <div className="login__logo">
          <OrbindLogo size={44} color="#FFFFFF" halo="var(--ob-primary)" />
        </div>
        <h1 className="login__brand-title">Orbind</h1>
      </section>
      <section className="login__panel">
        <Card className="login__card">
          {estado === 'confirmando' ? (
            <div className="ob-stack">
              <h2 className="login__title">Confirmando seu e-mail…</h2>
              <LoadingState variant="list" rows={2} label="Confirmando o e-mail" />
            </div>
          ) : (
            <div className="ob-stack">
              <h2 className="login__title">Link inválido ou expirado</h2>
              <Alert tone="danger" title="Não foi possível confirmar">
                Este link não é mais válido. Peça um reenvio na tela de login (ao tentar entrar, você verá a opção) ou
                cadastre-se novamente.
              </Alert>
              <Button variant="primary" onClick={() => navigate('/login')}>
                Ir para o login
              </Button>
            </div>
          )}
        </Card>
      </section>
    </div>
  )
}
